import React, { Component } from 'react';
import { connect } from 'react-redux';
import './forms.css';
import * as repositoryActions from '../../../Store/Actions/repositoryActions';

import TextBox from '../TextBox/textbox';
import Button from '../Button/button';
import ComboBox from '../ComboBox/combobox';
import DropZone from '../DropZone/dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/*
PARAMETERS :
  create : true/false
  object : {} // object to update or null if create = true,
  reservedValue : {COLUMNNAME:[ARRAY OF RESERVED VALUE]}
*/
class docForm extends Component {
  constructor(props) {
    super(props);
    // State is in reducers
    this.state = {
      page:0,
      create:true,
      endPoint:"DOC",
      blankObject:{
        AC_001: 2,
        ARCS: 0,
        Categories: [],
        FILE: [],
        FLAG: 100,
        FRMT: "",
        HISTORIQUE: 0,
        INFORMATION: "",
        IU: "R",
        NSYS: 4,
        SIT: 1,
        Session: {},
        SessionIDE: "",
        Status: 0,
        WORDING: "",
      }
    };

  }

  // BUILDING METHOD DO NOT CHANGE
  componentDidMount = () =>{
    var node = {...this.props.node};
    // GET THE OBJECT IF ID is provided
    
    if(this.props.id > 0){
      this.props.get_single_object(this.props.sessionId,this.props.id,this.state.endPoint);
      this.setState({create:false});
    }else{
      this.setState({create:true});
      this.props.onCreateBlank(this.state.blankObject);
    }

    // GET CATEGORIES
    //this.props.get_list_object(this.props.sessionId,"EN3",node,true,this.state.page);
  }


  // INNER METHOD 

  //GENERIC DO NOT CHANGE
  onClickCancel = () =>{
    this.props.onCancelForm();
  }

  // MAY CHANGE
  // ADD ALERT MANAGEMENT FOR UNIQUE REF
  onClickValid = () =>{
    var object = this.props.newObject;
    if(this.state.create){
      // CHECK RESERVED VALUE UNIQUE ISO_3166_1_ALPHA2
          // if(this.props.dataSet.map(item=>item.ISO_3166_1_ALPHA2).includes(object.ISO_3166_1_ALPHA2)){
          //   alert("the value : "+object.ISO_3166_1_ALPHA2+ " should be unique and is already in use for column :"+"ISO_3166_1_ALPHA2");
          // }else{
            this.props.onSave(object,true);
          // }
    }else{
      this.props.onSave(object,true);
    }
  }

  //GENERIC DO NOT CHANGE
  onUpdateValue = (columnName,e) =>{
    this.props.onUpdateValue(columnName,e);
  }

  //GENERIC
  onSelectedItems = (ids) =>{
    this.props.onUpdateValue("CATEGORIES",ids[0]);
  }

  readFileByteArray = (files) =>{
    new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
          resolve(event.target.result);
      };

      reader.onerror = (err) => {
          reject(err);
      };

      reader.readAsArrayBuffer(files[0]);
    }).then(ba=>{
      this.props.onUpdateValue("FILE",ba);
    });

    
  }

  createAndDownloadBlobFile = (ba, filename, extension) => {
    const arrayBuffer = new Uint8Array(ba);
    const blob = new Blob(arrayBuffer,{type:extension});
    console.log("ARRAY BUFFER",ba);
    const fileName = `${filename}.${extension}`;
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
  downloadFile = ()=>{
    var arrayBuffer = new Uint8Array(this.props.newObject.FILE);
    var blob = new Blob(arrayBuffer,{type:this.props.newObject.FRMT});
    var fileName = `${this.props.newObject.WORDING}.${this.props.newObject.FRMT}`;

    console.log("ARRAY BUFFER",arrayBuffer);
    
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      var link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        var url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  renderFile = ()=>{
    var content = null;
    switch(this.props.newObject.FRMT){
      case "PDF":
        content = <div className="fileDownload" onClick={this.downloadFile.bind()}>
          <FontAwesomeIcon icon="file-alt"/>
          <div>
            {this.props.newObject.WORDING+"."+this.props.newObject.FRMT}
          </div>
        </div>;
        break;
      case "CSV":
        content = <div className="fileDownload" onClick={this.downloadFile.bind()}>
          <FontAwesomeIcon icon="file-alt"/>
          <div>
            {this.props.newObject.WORDING+"."+this.props.newObject.FRMT}
          </div>
        </div>;
        break;
      default:
        content = <div className="fileDownload" onClick={this.downloadFile.bind()}>
          <FontAwesomeIcon icon="file-alt"/>
          <div>
            {this.props.newObject.WORDING+"."+this.props.newObject.FRMT}
          </div>
        </div>;
        break;  

    }
    return (content)

  }

  render() {
 
    var content = this.props.newObject !== null ?
    <div>
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Identification (id : {this.state.create?0:this.props.newObject.ARCS})</span>
            <div className="section-status valid"></div>
          </div>
          <div className="section-body">
             {/* Wording */}
            <div className="section-item column-1">
              <label>Name</label>
              <TextBox 
                config={
                  {
                    mask:null, 
                    color:"#999",
                    readOnly:false, 
                    maxLength:null, 
                    textAlign:"left"
                  }
                } 
                updateValue={this.onUpdateValue.bind(this,"WORDING")}
                value = {this.props.newObject !== undefined? this.props.newObject["WORDING"]:""}
              />
            </div>
            {/* FILE */}
            <div className="section-item column-3">
              <label>File</label>
              <DropZone getFile={this.readFileByteArray.bind()}></DropZone>
            </div>
            <div className="section-item column-3">
              {this.props.newObject !== undefined? 
              this.renderFile()
              :
              null
              }
              
            </div>
          </div>
        </div>
        
        <div className="form-section">
          <div>
            <Button 
              preventMultipleClick={0} 
              config={
                {
                  isEnabled:true,
                  icon:"check",
                  text:"save change",
                  color:null,
                  textAlign:"center",
                  bgcolor:null
                }
              } 
              OnClickElement={this.onClickValid.bind(this)}
            />
          </div>
        </div>
      </div>
    :
      null
    ;

    return (
      <div className="form-container" >
        {content}
      </div>
         
    );
  }
}

  const mapStateToProps = (state) => {    
    return {  
      newObject:state.apiReducer.newObject,
      sessionId: state.apiReducer.sessionId,
      dataSet:state.apiReducer.workingData,
      listOptions:state.apiReducer.listOptions,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return { 
      get_single_object: (sessionId,id,endPoint) =>dispatch(repositoryActions.get_single_object(sessionId,id,endPoint)),
      onUpdateValue:(columnName,e)=>dispatch(repositoryActions.onUpdateValue(columnName,e)),
      onCreateBlank:(object)=>dispatch(repositoryActions.onCreateBlank(object)),
      get_list_object: (sessionId,endPoint,node,getOptions,page) =>dispatch(repositoryActions.get_list_object(sessionId,endPoint,node,getOptions,page)),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(docForm);